module.exports = __webpack_public_path__ + "media/icon_transaction/rabit-905ad931.png";